module.exports = __webpack_public_path__ + "static/media/DSC_0131.3c59e0d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0131.jpg
// module id = 689
// module chunks = 0